import { useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { normalizePhone, formatPhone } from "./lib/phone.js";

export default function NewTextDialog({ open, onClose, onSend, byPhone }) {
  const [to, setTo] = useState("");
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const normalized = normalizePhone(to);
  const match = normalized ? byPhone.get(normalized) : null;

  async function send() {
    if (!normalized) {
      setError("Enter a valid phone number. A 10-digit number is read as a US number.");
      return;
    }
    if (!body.trim()) return;
    setBusy(true);
    setError(null);
    try {
      await onSend(normalized, body.trim());
      setTo("");
      setBody("");
      onClose();
    } catch (e) {
      setError(e?.body?.detail || e?.message || "The kernel refused this send.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>New text</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="To"
            placeholder="(619) 555-0100 or +16195550100"
            value={to}
            onChange={(e) => setTo(e.target.value)}
            autoFocus
          />
          {to ? (
            <Typography variant="caption" color={normalized ? "text.secondary" : "error"}>
              {normalized
                ? `${match ? match.displayName + " \u00b7 " : "Not in your contacts \u00b7 "}${formatPhone(normalized)}`
                : "Not a number this app can send to."}
            </Typography>
          ) : null}
          <TextField label="Message" multiline minRows={3} value={body} onChange={(e) => setBody(e.target.value)} />
          {error ? (
            <Alert severity="error" variant="outlined">
              {error}
            </Alert>
          ) : null}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          Cancel
        </Button>
        <Button variant="contained" onClick={send} disabled={busy || !to.trim() || !body.trim()}>
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
}
